import React, { useState, useEffect, useMemo } from 'react'
import { Input, Form, Radio } from 'antd'
import { useAppSelector, useAppDispatch } from '../../../../app/hooks'
import {
  setEditorCascadeItemsList,
  setEditorWatermark
} from '../../../../actions/watermark'
import { subWatermarkText } from '../../../../utils/utils'
import { WATERMARK_CONFIG } from '../../../../constants/watermark'

// 条目配置类型
interface ItemConfigType {
  titleEditable?: boolean
  contentMaxSize?: number
  titleMaxSize?: number
}
import TextContent from './TextContent'
import PresetContent from './PresetContent'
import CascadeItems from './CascadeItems'
import MustFill from './MustFill'
import BunchAddPresetModal from './BunchAddPresetModal'
import VipIcon from '../../../../images/vip_icon_1.png'

const FormItem = Form.Item

function TitleContentItem(props) {
  const { item, index, clickEvent } = props
  const dispatch = useAppDispatch()
  const watermark = useAppSelector((state) => state.editor.watermark)
  const cascadeItems = useAppSelector((state) => state.editor.cascadeItems)

  const [bunchAddModalVisible, setBunchAddModalVisible] = useState(false)

  // 计算配置
  const itemConfig = useMemo((): ItemConfigType | undefined => {
    return WATERMARK_CONFIG[watermark.base_id]?.[item.id] as
      | ItemConfigType
      | undefined
  }, [watermark, item])

  const titleMaxLength = itemConfig?.titleMaxSize ?? 20
  const contentMaxLength = itemConfig?.contentMaxSize || 530
  const titleEditable =
    !itemConfig ||
    itemConfig.titleEditable === undefined ||
    itemConfig.titleEditable

  useEffect(() => {
    const contentEdit = watermark.items[index]?.contentEdit
    const itemsList = contentEdit?.itemsList || []
    // 如果是【预设员工选项】且 预设选项列表为空，则创建2个默认的选项：选项一，选项二
    if (contentEdit?.editType === 2 && (itemsList.length === 0 || !itemsList)) {
      const newItems = watermark.items.map((it, idx) =>
        idx === index
          ? {
              ...it,
              contentEdit: {
                ...it.contentEdit,
                itemsList: ['选项一', '选项二']
              }
            }
          : it
      )
      dispatch(setEditorWatermark({ ...watermark, items: newItems }))
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  const handleTabChange = (activeKey) => {
    const value = parseInt(activeKey)
    // 这里涉及到新旧版本转换，如果有contentEdit（新）,使用contentEdit.editType，否则（旧）使用item.editType
    let newItems = watermark.items.map((it, idx) =>
      idx === index
        ? {
            ...it,
            editType: 2,
            contentEdit: {
              ...it.contentEdit,
              editType: value
            }
          }
        : it
    )
    // 如果用户切换到【预设选项】且 标签选项列表为空，则创建2个默认的标签：选项一，选项二
    if (
      activeKey === '2' &&
      (watermark.items[index]?.contentEdit?.itemsList?.length === 0 ||
        !watermark.items[index]?.contentEdit?.itemsList)
    ) {
      newItems = newItems.map((it, idx) =>
        idx === index
          ? {
              ...it,
              contentEdit: {
                ...it.contentEdit,
                itemsList: ['选项一', '选项二']
              }
            }
          : it
      )
    }
    // 如果用户切换到【多级选项】且 多级选项列表为空，则创建一个默认的多级选项
    if (activeKey === '3') {
      const cascadeItem = cascadeItems.find(
        (ci) => ci.itemId === watermark.items[index]?.id
      )
      if (!cascadeItem) {
        const defaultCascadeItem = {
          itemId: watermark.items[index]?.id,
          records: [
            {
              content: '一级选项',
              childs: [
                {
                  content: '二级选项'
                }
              ]
            }
          ]
        }
        dispatch(
          setEditorCascadeItemsList([...cascadeItems, defaultCascadeItem])
        )
      }
    }
    // 两个tab切换时，重置内容
    newItems = newItems.map((it, idx) =>
      idx === index
        ? {
            ...it,
            content: '',
            contentEdit: {
              ...it.contentEdit,
              placeholder: ''
            }
          }
        : it
    )
    dispatch(setEditorWatermark({ ...watermark, items: newItems }))

    if (activeKey === '0') {
      clickEvent('chooseText')
    } else if (activeKey === '2') {
      clickEvent('chooseOptin')
    } else if (activeKey === '3') {
      clickEvent('chooseMultiOption')
    }
  }

  const contentType =
    watermark.items[index]?.contentEdit?.editType < 2
      ? '0'
      : String(watermark.items[index]?.contentEdit?.editType)

  return (
    <div className="form-custom-item-container">
      <Form>
        {titleEditable && (
          <FormItem label="标题">
            <Input
              value={item.title}
              placeholder="请输入…"
              allowClear
              onChange={(e) => {
                const newItems = watermark.items.map((it, idx) =>
                  idx === index
                    ? {
                        ...it,
                        title: subWatermarkText(e.target.value, titleMaxLength)
                      }
                    : it
                )
                dispatch(setEditorWatermark({ ...watermark, items: newItems }))
              }}
            />
          </FormItem>
        )}

        <FormItem
          label="内容类型"
          labelAlign="left"
          labelCol={{ span: 3 }}
          wrapperCol={{ span: 21 }}
        >
          <Radio.Group
            value={contentType}
            onChange={(e) => handleTabChange(e.target.value)}
          >
            <Radio value={'0'}>文本</Radio>
            <Radio value={'2'}>选项</Radio>
            <Radio value={'3'}>
              多级选项
              <img
                style={{ width: 22, marginLeft: 2, verticalAlign: 'middle' }}
                src={VipIcon}
              />
            </Radio>
          </Radio.Group>
        </FormItem>

        <MustFill index={index} clickEvent={clickEvent} />

        {contentType === '0' && (
          <TextContent index={index} contentMaxLength={contentMaxLength} />
        )}
        {contentType === '2' && (
          <PresetContent
            index={index}
            clickEvent={clickEvent}
            onBunchAddClick={() => {
              setBunchAddModalVisible(true)
              clickEvent('batchAddOption')
            }}
          />
        )}
        {contentType === '3' && (
          <CascadeItems index={index} clickEvent={clickEvent} />
        )}
      </Form>
      <BunchAddPresetModal
        index={index}
        visible={bunchAddModalVisible}
        onCancel={() => setBunchAddModalVisible(false)}
      />
    </div>
  )
}

export default TitleContentItem
